import { observer } from "mobx-react-lite";

import { useAuth } from "../../contexts/authContext";
import { useJanusContext } from "../../contexts/janus/JanusContext";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useUserMedia } from "../../hooks/useUserMedia";

import CurrentMeetingUsersStatusBar from "./current-meeting-actions-and-details/current-meeting-users-status-bar";
import { UsersCameraAndControls } from "./users-camera-and-controls";

export const LiveWorkspaceWidget = observer(() => {
  const { isJoining, isJoined, userMediaPermissionsGranted } = useMeetingDetailsStore();
  const { inRoomParticipants } = useJanusContext();
  const { previewCamStream } = useUserMedia();
  const { userData } = useAuth();

  const filteredParticipants = inRoomParticipants.filter((participant) => participant.display !== userData.email);

  return (
    <div className="live-workspace-widget-wrap">
      {(previewCamStream || userMediaPermissionsGranted) && <UsersCameraAndControls />}
      {!!filteredParticipants.length && (isJoining || isJoined) && (
        <>
          <div className="divider-vertical current-meeting-status-bar-list-users" />
          <CurrentMeetingUsersStatusBar />
        </>
      )}
    </div>
  );
});
